import React from 'react';
import { FaExclamationTriangle, FaSignOutAlt } from 'react-icons/fa';
import { HELIXOPS_EMAIL_DOMAIN } from '../Constants/emailMigration';

const COPY = {
  updateRequired: {
    icon: <FaExclamationTriangle />,
    title: 'Email Update Required',
    message: `Tech Central now requires your ${HELIXOPS_EMAIL_DOMAIN} email. Please update your email address to continue.`,
    buttonLabel: 'Update Now',
  },
  alreadyCompleted: {
    icon: <FaSignOutAlt />,
    title: 'Email Already Updated',
    message: `Your email has already been updated to your ${HELIXOPS_EMAIL_DOMAIN} account. Please log out and sign in again using your new email.`,
    buttonLabel: 'Log Out Now',
  },
};

const EmailMigrationBanner = ({ mode = 'updateRequired', onUpdateNow, onLogoutNow }) => {
  const content = COPY[mode] || COPY.updateRequired;
  const handleClick = mode === 'alreadyCompleted' ? onLogoutNow : onUpdateNow;

  return (
    <div className="email-migration-shell" role="region" aria-labelledby="email-migration-title">
      <div className="email-migration-banner">
        <div className="email-migration-banner__icon" aria-hidden="true">
          {content.icon}
        </div>
        <div className="email-migration-banner__content">
          <h2 id="email-migration-title" className="email-migration-banner__title">
            {content.title}
          </h2>
          <p className="email-migration-banner__message">
            {content.message}
          </p>
        </div>
        <div className="email-migration-banner__actions">
          <button type="button" className="email-migration-banner__button email-migration-banner__button--primary" onClick={handleClick}>
            {content.buttonLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailMigrationBanner;
